import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import localeEsCo from '@angular/common/locales/es-CO';
import { ClipboardModule } from 'ngx-clipboard';

import { AppRoutingModule } from './modules/app-routing.module';
import { MaterialModule } from './modules/material.module';
import { UserService } from './services/user.service';
import { StatisticsService } from './services/statistics.service';
import { EditionsService } from './services/editions.service';
import { MainToolbarComponent } from './components/main-toolbar/main-toolbar.component';
import { MainTypeComponent } from './components/main-type/main-type.component';
import { AppComponent } from './app.component';
import { MainHomeComponent } from './components/main-home/main-home.component';
import { EditionStatisticsComponent } from './components/edition-statistics/edition-statistics.component';
import { SearchEdictComponent } from './components/search-edict/search-edict.component';
import { SearchTypeEdictComponent } from './components/search-type-edict/search-type-edict.component';
import { OrderService } from './services/order.service';
import { TypeOrderComponent } from './components/type-order/type-order.component';
import { TypeOrderTableComponent } from './components/type-order-table/type-order-table.component';
import { TypeOrderItemComponent } from './components/type-order-item/type-order-item.component';
import { BaseService } from './services/base.service';
import { TypeControlComponent } from './components/type-control/type-control.component';
import { TinyEditorComponent } from './components/tiny-editor/tiny-editor.component';
import { OrderComponent } from './components/order/order.component';
import { OrderTableComponent } from './components/order-table/order-table.component';
import { OrderItemComponent } from './components/order-item/order-item.component';
import { OrderHistoryComponent } from './components/order-history/order-history.component';
import { SearchValidateEdictComponent } from './components/search-validate-edict/search-validate-edict.component';
import { ValidateOrderComponent } from './components/validate-order/validate-order.component';
import { ValidateOrderTableComponent } from './components/validate-order-table/validate-order-table.component';
import { TimeService } from './services/time.service';
import { OrderDocumentHistoryComponent } from './components/order-document-history/order-document-history.component';
import { MainReportComponent } from './components/main-report/main-report.component';
import { registerLocaleData } from '@angular/common';
import { AdminProductsComponent } from './components/admin-products/admin-products.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { AdminUsersComponent } from './components/admin-users/admin-users.component';
import { AdminBranchesComponent } from './components/admin-branches/admin-branches.component';
import { AdminRolesComponent } from './components/admin-roles/admin-roles.component';
import { AdminUserDetailComponent } from './components/admin-user-detail/admin-user-detail.component';

import { OcrService } from './services/ocr.service';
import { OcrControlComponent } from './components/ocr-control/ocr-control.component';
import { ProductNewComponent } from './components/product-new/product-new.component';
import { MainPublishComponent } from './components/main-publish/main-publish.component';
import { PublishEditionComponent } from './components/publish-edition/publish-edition.component';
import { PublishService } from './services/publish.service';
import { AuthGuardService } from './services/auth-guard.service';
import { LoginComponent } from './components/login/login.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LogoutComponent } from './components/logout/logout.component';
import { AdminEditionsComponent } from './components/admin-editions/admin-editions.component';
import { AdminNewEditionComponent } from './components/admin-new-edition/admin-new-edition.component';
import { ConfirmDeleteDialogComponent } from './components/admin-editions/admin-editions.component';
import { AdminUserCreateComponent } from './components/admin-user-create/admin-user-create.component';
import { AdminRolesDetailComponent } from './components/admin-roles-detail/admin-roles-detail.component';
import { CertIndexComponent } from './components/cert-index/cert-index.component';
import { CertDetailComponent } from './components/cert-detail/cert-detail.component';

registerLocaleData(localeEsCo, 'es-CO');

@NgModule({
  declarations: [
    AppComponent,
    MainToolbarComponent,
    MainTypeComponent,
    MainHomeComponent,
    EditionStatisticsComponent,
    SearchEdictComponent,
    SearchTypeEdictComponent,
    TypeOrderComponent,
    TypeOrderTableComponent,
    TypeOrderItemComponent,
    TypeControlComponent,
    TinyEditorComponent,
    OrderComponent,
    OrderTableComponent,
    OrderItemComponent,
    OrderHistoryComponent,
    SearchValidateEdictComponent,
    ValidateOrderComponent,
    ValidateOrderTableComponent,
    OrderDocumentHistoryComponent,
    MainReportComponent,
    AdminProductsComponent,
    ProductDetailComponent,
    AdminUsersComponent,
    AdminBranchesComponent,
    AdminRolesComponent,
    AdminUserDetailComponent,
    OcrControlComponent,
    ProductNewComponent,
    MainPublishComponent,
    PublishEditionComponent,
    LoginComponent,
    ForbiddenComponent,
    NoAccessComponent,
    NotFoundComponent,
    LogoutComponent,
    AdminEditionsComponent,
    AdminNewEditionComponent,
    ConfirmDeleteDialogComponent,
    AdminUserCreateComponent,
    AdminRolesDetailComponent,
    CertIndexComponent,
    CertDetailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ClipboardModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    HttpClientModule
  ],
  entryComponents: [
    AdminUserDetailComponent,
    AdminUserCreateComponent,
    AdminNewEditionComponent,
    ConfirmDeleteDialogComponent,
    AdminRolesDetailComponent
  ],
  providers: [

    AuthGuardService,
    BaseService,
    EditionsService,
    OrderService,
    OcrService,
    PublishService,
    StatisticsService,
    UserService,
    TimeService,
    { provide: LOCALE_ID, useValue: 'es-CO' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
